import React from "react";
import { Row, Col, Form } from "react-bootstrap";

function VehicleEquipmentDetails({ values, setFieldValue, errors, touched }) {
  return (
    <Row className="mb-3">
      {/* Columna Izquierda: Notas */}
      <Col md={6}>
        <Form.Group className="mb-3">
          <Form.Label>Notas</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="notas"
            placeholder="Notas generales del vehículo"
            value={values.notas}
            onChange={(e) => setFieldValue("notas", e.target.value)}
            isInvalid={!!errors.notas}
          />
          <Form.Control.Feedback type="invalid">
            {errors.notas}
          </Form.Control.Feedback>
        </Form.Group>
      </Col>

      {/* Columna Derecha: Switches */}
      <Col md={6}>
        {[
          { name: "extinguidor", label: "Extinguidor" },
          { name: "llanta_refaccion", label: "Llanta de Refacción" },
          { name: "gato", label: "Gato" },
          { name: "herramientas", label: "Herramientas" },
          {
            name: "cable_pasa_corriente",
            label: "Cable para Paso de Corriente",
          },
          { name: "senalamientos", label: "Señalamientos" },
          { name: "otros", label: "Otros" },
        ].map(({ name, label }) => (
          <Form.Group as={Col} md="12" key={name} className="mb-2">
            <Form.Check
              type="switch"
              name={name}
              label={label}
              checked={values[name]}
              onChange={(e) => {
                const checked = e.target.checked;
                setFieldValue(name, checked);
                if (name === "otros" && !checked) {
                  setFieldValue("otros_observaciones", "");
                }
              }}
            />
          </Form.Group>
        ))}

        {/* Mostrar TextArea si "otros" es true */}
        {values.otros && (
          <Form.Group className="mt-3">
            <Form.Label>Descripción de la maniobra</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="otros_observaciones"
              placeholder="Descripción de la maniobra"
              value={values.otros_observaciones}
              onChange={(e) =>
                setFieldValue("otros_observaciones", e.target.value)
              }
              isInvalid={!!errors.otros_observaciones}
            />
            <Form.Control.Feedback type="invalid">
              {errors.otros_observaciones}
            </Form.Control.Feedback>
          </Form.Group>
        )}
      </Col>
    </Row>
  );
}

export default VehicleEquipmentDetails;
